// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Rules Engine (admin) — §3 threshold config form.
 * Uses redesign-system primitives (.rd-field/.rd-input/.rd-btn).
 */
.ent.rules-engine-page { padding: 24px; }

.ent.rules-engine-page .rules-card { margin-top: 8px; }
.ent.rules-engine-page .rules-card__head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}
.ent.rules-engine-page .rules-card__head svg { color: var(--accent, #6366f1); margin-top: 2px; flex-shrink: 0; }
.ent.rules-engine-page .rules-card__head h2 { margin: 0; font-size: 1rem; font-weight: 700; color: var(--ink); }
.ent.rules-engine-page .rules-card__head p { margin: 2px 0 0; font-size: 0.82rem; color: var(--ink-muted); }

.ent.rules-engine-page .rules-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.ent.rules-engine-page .rules-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ent.rules-engine-page .rules-input-row .rd-input { flex: 1 1 auto; min-width: 0; }
.ent.rules-engine-page .rules-unit {
  font-size: 12.5px;
  color: var(--ink-secondary);
  white-space: nowrap;
  flex-shrink: 0;
}

.ent.rules-engine-page .rules-actions {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .ent.rules-engine-page { padding: 16px; }
  .ent.rules-engine-page .rules-grid { grid-template-columns: 1fr; gap: 16px; }
}
@media (max-width: 576px) {
  .ent.rules-engine-page .rules-actions { justify-content: stretch; }
  .ent.rules-engine-page .rules-actions .rd-btn { width: 100%; min-height: 44px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/RulesEngine.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,yBAAyB,aAAa,EAAE;;AAExC,qCAAqC,eAAe,EAAE;AACtD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA,+CAA+C,6BAA6B,EAAE,eAAe,EAAE,cAAc,EAAE;AAC/G,8CAA8C,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/G,6CAA6C,eAAe,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;;AAE3G;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,oDAAoD,cAAc,EAAE,YAAY,EAAE;AAClF;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,aAAa,EAAE;EACxC,qCAAqC,0BAA0B,EAAE,SAAS,EAAE;AAC9E;AACA;EACE,wCAAwC,wBAAwB,EAAE;EAClE,gDAAgD,WAAW,EAAE,gBAAgB,EAAE;AACjF","sourcesContent":["/*\n * Rules Engine (admin) — §3 threshold config form.\n * Uses redesign-system primitives (.rd-field/.rd-input/.rd-btn).\n */\n.ent.rules-engine-page { padding: 24px; }\n\n.ent.rules-engine-page .rules-card { margin-top: 8px; }\n.ent.rules-engine-page .rules-card__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n.ent.rules-engine-page .rules-card__head svg { color: var(--accent, #6366f1); margin-top: 2px; flex-shrink: 0; }\n.ent.rules-engine-page .rules-card__head h2 { margin: 0; font-size: 1rem; font-weight: 700; color: var(--ink); }\n.ent.rules-engine-page .rules-card__head p { margin: 2px 0 0; font-size: 0.82rem; color: var(--ink-muted); }\n\n.ent.rules-engine-page .rules-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.ent.rules-engine-page .rules-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ent.rules-engine-page .rules-input-row .rd-input { flex: 1 1 auto; min-width: 0; }\n.ent.rules-engine-page .rules-unit {\n  font-size: 12.5px;\n  color: var(--ink-secondary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ent.rules-engine-page .rules-actions {\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n  .ent.rules-engine-page { padding: 16px; }\n  .ent.rules-engine-page .rules-grid { grid-template-columns: 1fr; gap: 16px; }\n}\n@media (max-width: 576px) {\n  .ent.rules-engine-page .rules-actions { justify-content: stretch; }\n  .ent.rules-engine-page .rules-actions .rd-btn { width: 100%; min-height: 44px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
